import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../../components/states';
// import { useTranslation } from 'react-i18next';
import InstitutionForm from '../../../../components/forms/InstitutionForm';
import Loader from '../../../../components/Loader';
import { useFetch } from '../../../../hooks/useFetch';

export default function InstitutionsEditPage() {
  // const { t } = useTranslation();
  const { itemId } = useParams();

  const { requestApi, data, error } = useFetch(`/v1/admin/institutions/${itemId}`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <InstitutionForm defaultValues={data?.data} /> : <Loader />;
}
